import { gql } from "@apollo/client";
import {
  EmailAiExtractedDataTableType,
  EmailAiExtractedDataType,
  EmailType,
  MailboxSessionType,
  MailboxType,
  EmailProcessingStatsType,
  NoSubmissionsEmailType,
  UnprocessedEmailListType,
  FailedEmailListType,
  ApiLogsType,
  UserType
} from "./schemeTypes";

export const USER = gql`
  query me {
    me ${UserType}
  }
`;

export const MAILBOX_SESSIONS = gql`
  query mailboxSessions {
    mailboxSessions ${MailboxSessionType}
  }
`;

export const MAILBOXES = gql`
  query mailboxes {
    mailboxes ${MailboxType}
  }
`;

export const PROCESSED_EMAILS = gql`
  query processedEmail(
    $page: Int!, 
    $limit: Int!,
    $businessName: String,
    $dba: String,
    $owner: String,
    $ssn: String,
    $processingDate: String,
  ) {
    processedEmail(
      page: $page, 
      limit: $limit,
      businessName: $businessName,
      dba: $dba,
      owner: $owner,
      ssn: $ssn,
      processingDate: $processingDate,
    ) {
      items ${EmailAiExtractedDataTableType}
      totalCount
      totalPages
      hasNext
    }
  }
`;

export const REVIEW_EMAILS = gql`
  query reviewEmails(
    $page: Int!, 
    $limit: Int!,
    $businessName: String,
    $dba: String,
    $owner: String,
    $ssn: String,
    $processingDate: String,
  ) {
    reviewEmails(
      page: $page, 
      limit: $limit,
      businessName: $businessName,
      dba: $dba,
      owner: $owner,
      ssn: $ssn,
      processingDate: $processingDate,
    ) {
      items ${EmailAiExtractedDataTableType}
      totalCount
      totalPages
      hasNext
    }
  }
`;

export const REVIEW_EMAIL = gql`
  query reviewEmail($emailId: ID!) {
    reviewEmail(emailId: $emailId) ${EmailAiExtractedDataType}
  }
`;

export const UNPROCESSED_EMAILS = gql`
  query unprocessedEmails($page: Int!, $limit: Int!) {
    unprocessedEmails(page: $page, limit: $limit) {
      items ${UnprocessedEmailListType}
      totalCount
      totalPages
      hasNext
    }
  }
`;

export const FAILED_EMAILS = gql`
  query failedEmails($page: Int!, $limit: Int!) {
    failedEmails(page: $page, limit: $limit) {
      items ${FailedEmailListType}
      totalCount
      totalPages
      hasNext
    }
  }
`;

export const EMAIL_PROCESSING_STATS = gql`
  query emailProcessingStats {
    emailProcessingStats ${EmailProcessingStatsType} 
  }
`;

export const API_LOGS = gql`
  query crmApiLogs($page: Int!, $limit: Int!) {
    crmApiLogs(page: $page, limit: $limit) {
      items ${ApiLogsType}
      totalCount
      totalPages
      hasNext
    }
  }
`;

export const ALL_MAILBOX_PROCESSING = gql`
  query allMailboxProcessingPercent {
    allMailboxProcessingPercent {
      percent
    }
  }
`;

export const ALL_AGENTS = gql`
  query allAgents {
    allAgents {
      company
      email
      firstName
      lastName
      phoneNumber
      id
    }
  }
`;

export const DATA_FOR_FILTERS_IN_REVIEW_AND_PROCESSED_EMAILS = gql`
  query dataForFiltersInReviewAndProcessedEmails($isFailedEmails: Boolean!) {
    dataForFiltersInReviewAndProcessedEmails(isFailedEmails: $isFailedEmails) {
      businessNames
      dbas
      owners
      ssns
      processingDates
    }
  }
`
